import React, { FC, ReactNode } from 'react';
import { Card } from '@agro1desenvolvimento/react-components';

interface AuthCardProps {
  title: string;
  children: ReactNode;
  footer?: ReactNode;
}

const AuthCard: FC<AuthCardProps> = ({ title, children, footer }) => (
  <div className="p-d-flex p-jc-center auth-page">
    <Card
      className="p-as-center p-p-5 auth-card"
      footer={footer}
    >
      <div className="p-grid p-fluid">
        <img
          src="/logo.png"
          alt="Logo"
          className="p-col-12 p-text-center auth-logo"
        />
        <h1 className="p-col-12 p-text-center auth-title">
          {title}
        </h1>
        {children}
      </div>
    </Card>
  </div>
);

export default AuthCard;
